import { dbAdd, dbDelete, dbGetAll, dbPut } from '../indexedDb.ts';

export type SyncMethod = 'POST' | 'PUT' | 'PATCH' | 'DELETE';

export interface SyncQueueEntityRef {
  type:
    | 'accounts'
    | 'categories'
    | 'transactions'
    | 'tasks'
    | 'recurring_transactions'
    | 'objectives'
    | 'key_results'
    | 'indicators'
    | 'investment_plans'
    | 'investment_scenarios'
    | 'investment_ledgers'
    | 'investment_records'
    | 'investment_allocations'
    | 'investment_goals';
  local_id?: number;
  server_id?: number;
}

export interface SyncQueueItem {
  id?: number;
  method: SyncMethod;
  url: string;
  body?: any;
  params?: any;
  entity?: SyncQueueEntityRef;
  status: 'pending' | 'failed';
  attempts: number;
  created_at: string;
  last_attempt_at?: string;
  last_error?: string;
}

export async function enqueueSyncItem(item: Omit<SyncQueueItem, 'id' | 'status' | 'attempts' | 'created_at'>) {
  const now = new Date().toISOString();
  return dbAdd('sync_queue', {
    ...item,
    status: 'pending',
    attempts: 0,
    created_at: now,
  } as any);
}

export async function listPendingSyncItems(): Promise<SyncQueueItem[]> {
  const all = await dbGetAll<SyncQueueItem>('sync_queue');
  return all
    .filter((item) => item.status === 'pending')
    .sort((a, b) => (a.id || 0) - (b.id || 0));
}

export async function listAllSyncItems(): Promise<SyncQueueItem[]> {
  const all = await dbGetAll<SyncQueueItem>('sync_queue');
  return all.sort((a, b) => (a.id || 0) - (b.id || 0));
}

export async function updateSyncItem(item: SyncQueueItem) {
  if (!item.id) {
    throw new Error('Sync queue item missing id');
  }
  return dbPut('sync_queue', item as any);
}

export async function deleteSyncItem(id: number) {
  return dbDelete('sync_queue', id);
}
